import { ReactComponent as OrangeCrossSvg } from 'approot/shared/icons/icon_orange_cross.svg';
import * as Styled from './differentiation.style';

type Props = {
  size?: number;
  marginRight?: number;
  number?: number;
  fontSize?: number;
  'data-selector'?: string;
};

const OrangeCross = ({
  number,
  size,
  marginRight,
  fontSize,
  'data-selector': dataSelector,
}: Props) => {
  return (
    <Styled.OrangeCrossWrapper
      $width={size}
      $height={size}
      $marginRight={marginRight}
      $fontSize={fontSize}
      data-selector={dataSelector}
    >
      <OrangeCrossSvg width={size} height={size} />
      {number && (
        <Styled.OrangeCrossNumber $size={size} data-selector={dataSelector}>
          {number}
        </Styled.OrangeCrossNumber>
      )}
    </Styled.OrangeCrossWrapper>
  );
};

export default OrangeCross;
